<template>
  <el-row>
    <h4>基础设置</h4>
    <el-divider></el-divider>
    <el-form :model="WechatShareInfoForm"
             ref="WechatShareInfoRef"
             :rules="rules"
             @onSelectInfo="onSelectInfo"
             @onAdded="onSaved"
             @onEdited="onSaved"
             addAction=""
             editAction="/channel/updateChannelConfig.action"
             selectAction="/channel/selectChannelConfig.action"
             label-width="150px"
             style="width:50%"
             v-form>
      <el-form-item label="网站名称：" prop="channelPageName">
        <el-input placeholder="请输入（建议5字以内）" v-model="WechatShareInfoForm.channelPageName"></el-input>
      </el-form-item>
      <!-- <el-form-item label="汽车网副标题：">
        <el-input placeholder="请输入（建议5字以内）" v-model="WechatShareInfoForm.auxiliaryNote"></el-input>
      </el-form-item>-->
      <el-form-item label="添加公众号："  prop="qrcode">
        <el-upload v-model="WechatShareInfoForm.qrcode" :data="{floder:'carExhibition'}"  :http-request="onHttpRequest"
                   :show-file-list="false" accept="image/*" action="upload/uploadPic"
                   class="avatar-uploader">
          <img  :src="WechatShareInfoForm.qrcode.url" class="avatar" v-if="WechatShareInfoForm.qrcode">
          <i class="el-icon-plus avatar-uploader-icon" v-else></i>
          <div slot="tip" class="el-upload__tip" style="margin-top: -16px"><p>请上传公众号二维码图片，将用作图片水印 </p></div>
        </el-upload>

      </el-form-item>
      <el-form-item label="品牌LOGO："  prop="logo">
        <el-upload v-model="WechatShareInfoForm.logo" :data="{floder:'channelLogo'}"  :http-request="onHttpRequest"
                   :show-file-list="false" accept="image/*" action="upload/uploadPic"
                   class="avatar-uploader">
          <img  :src="WechatShareInfoForm.logo.url" class="avatar" v-if="WechatShareInfoForm.logo">
          <i class="el-icon-plus avatar-uploader-icon" v-else></i>
          <div slot="tip" class="el-upload__tip" style="margin-top: -16px"><p>请上传100*100px图片</p></div>
        </el-upload>

      </el-form-item>

      <el-form-item label="联系客服：" prop="customerServiceWechatImg">
        <draggable v-model="WechatShareInfoForm.customerServiceWechatImg" tag="ul" class="img-temp-list" draggable=".img-temp-item">
          <li class="img-temp-item" v-for="(item, i) in WechatShareInfoForm.customerServiceWechatImg" :key="i">
            <img :src="item.url" />
            <div class="img-action">
              <el-image  style="width: 20px; height: 20px"  alt="" :src="baseImageUrl+baseSmalIcon" :preview-src-list="[item.url]"></el-image>
              <i class="el-icon-delete" @click="removeFile(WechatShareInfoForm.customerServiceWechatImg,i)"></i>
            </div>
          </li>
          <el-upload
                  :show-file-list="false"
                  :before-upload="beforeAvatarUploadWecht"
                  :data="{floder:'wechat'}"
                  :file-list="WechatShareInfoForm.customerServiceWechatImg"
                  :http-request="onHttpRequest"
                  :limit="1"
                  accept="image/*"
                  action="upload/uploadPic"
                  list-type="picture-card"
                  multiple
                  ref="customerServiceWechatImg"
                  v-model="WechatShareInfoForm.customerServiceWechatImg">

            <i class="el-icon-plus"></i>
          </el-upload>

        </draggable>
        <p style="color:#666;"><span style="color:red;">自传尺寸：最多1张</span></p>
      </el-form-item>

      <h4>首页分享设置</h4>
      <el-divider></el-divider>
      <el-form-item label="微信分享大标题：">
        <el-input placeholder="请输入（建议5字以内）" v-model="WechatShareInfoForm.wechatTitle"></el-input>
      </el-form-item>
      <el-form-item label="微信分享小标：">
        <el-input placeholder="请输入（建议5字以内）" v-model="WechatShareInfoForm.wechatSubtitle"></el-input>
      </el-form-item>
      <el-form-item label="分享缩略图：" prop="wechatImg">
        <el-upload v-model="WechatShareInfoForm.wechatImg" :data="{floder:'carExhibition'}"  :http-request="onHttpRequest"
                   :show-file-list="false" accept="image/*" action="upload/uploadPic"
                   class="avatar-uploader">

          <img  :src="WechatShareInfoForm.wechatImg.url" class="avatar" v-if="WechatShareInfoForm.wechatImg">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
        <div style="color:#999;">请上传100*100px图片</div>
      </el-form-item>
      <el-form-item>
        <el-button type="primary">确定</el-button>
        <el-button @click="$router.back()">取消</el-button>
      </el-form-item>
    </el-form>
  </el-row>
</template>

<script>
import BasicPager from '@/mixins/BasicPager'
import Config from '@/framework/configs/Config'
export default {
  name: 'WechatShareInfo',
  extends: BasicPager,
  components: {},
  data: function () {
    return {
      baseUrl: Config.baseUrl,
      baseImageUrl: Config.imageUrl,
      baseSmalIcon: 'ClueDistribution/fdjxtb.png',
      rules: {
        channelPageName: [
          { required: true, message: '请输入汽车网名称', trigger: 'blur' }
        ]
      },
      WechatShareInfoForm: {
        id: null,
        auxiliaryNote: null,
        channelPageName: null,
        wechatImg: null,
        wechatSubtitle: null,
        wechatTitle: null,
        qrcode: null,
        logo: null,
        customerServiceWechatImg: []
      }
    }
  },
  created () {
    let userInfo = JSON.parse(localStorage.userInfo)

    if (userInfo.loginPath === 'channel') {
      this.WechatShareInfoForm.id = userInfo.id
    }
  },
  methods: {
    removeFile (list, index) {
      list.splice(index, 1)
    },
    beforeAvatarUploadWecht: function (file) {
      let _this = this
      var promise = new Promise(function (resolve, reject) {
        const isLt5M = file.size / 1024 / 1024 < 15
        if (!isLt5M) {
          _this.$message.error('上传图片大小不能超过 15MB!')
          reject(new Error('上传图片大小不能超过 15MB!'))
          return
        }
        if (_this.WechatShareInfoForm.customerServiceWechatImg.length >= 1) {
          _this.$message.error('最多只能上传1张!')
          reject(new Error('最多只能上传1张!'))
          return
        }
        resolve()
      })
      return promise
    },
    onSaved () {
      this.$message({ type: 'success', message: '操作成功！' })
      return true
    },
    onFilterParams: function (params) {},
    onSelectInfo: function (dataInfo) {

    },
    beforeAvatarUpload: function (file) {
      let _this = this
      var promise = new Promise(function (resolve, reject) {
        const isLt2M = file.size / 1024 < 150
        if (!isLt2M) {
          _this.$message.error('上传头像图片大小不能超过 150 KB!')
          reject(new Error('上传头像图片大小不能超过 150 KB!'))
          return
        }

        var reader = new FileReader()
        reader.onload = function (e) {
          var data = e.target.result
          // 加载图片获取图片真实宽度和高度
          var image = new Image()
          image.onload = function () {
            var width = image.width
            var height = image.height

            if (width === 100 && height === 100) {
              resolve()
            } else {
              _this.$message({
                type: 'error',
                message: '图片必须等于100px*100px'
              })
              reject(new Error('图片必须等于100px*100px'))
            }
          }
          image.src = data
        }
        reader.readAsDataURL(file)
      })
      return promise
    }
  },
  filters: {}

}
</script>

<style scoped>

  .img-temp-list {
    padding-left: 0;
    display: flex;
    align-items: center;
    flex-warp: warp;
  }

  .img-temp-item {
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 148px;
    height: 148px;
    margin: 0 8px 8px 0;
    display: inline-block;
    position: relative;
  }

  .img-temp-item img {
    width: 100%;
    height: 100%;
  }
  .img-temp-item:hover .img-action {
    opacity: 1;
  }

  .img-temp-item .img-action {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s;
    opacity: 0;
  }
  .img-action i {
    font-size: 20px;
    color: #fff;
    margin-left: 15px;
    cursor: pointer;
  }
  .img-action i:first-child {
    margin-left: 0;
  }
</style>
